import { useMemo } from 'react';

let id = 0;

/**
 * Returns a unique id each time the function is called.
 */
function uniqueId() {
  return `dsx-${id++}`;
}

/**
 * A hook returning a memoized unique id.
 */
function useUniqueId() {
  return useMemo(() => uniqueId(), []);
}

export { uniqueId, useUniqueId };
